import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, LogOut, Download } from "lucide-react";
import "./navigationBar.scss";
import logo from "../assets/logo copy 2.png";
import Swal from "sweetalert2";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Cek path aktif
  const navLinks = [
    { label: "Dashboard", path: "/admin/dashboard" },
    { label: "Buat Akun", path: "/admin/buat-akun" },
    { label: "Buat Pembayaran", path: "/admin/buat-pembayaran" },
    { label: "List Akun", path: "/admin/list-akun" },
  ];

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Yakin ingin logout?",
      text: "Anda akan keluar dari akun admin.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: "Ya, logout",
      cancelButtonText: "Batal",
    });

    if (result.isConfirmed) {
      localStorage.removeItem("adminToken");
      sessionStorage.removeItem("adminToken");
      Swal.fire("Logout berhasil", "Anda telah keluar.", "success");
      navigate("/login-admin");
    }
  };

  const handleBackup = async () => {
    try {
      Swal.fire({
        title: 'Mempersiapkan Backup...',
        text: 'Mohon tunggu sebentar, file backup sedang dibuat.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const token = localStorage.getItem("adminToken") || sessionStorage.getItem("adminToken");
      const response = await fetch("/api/backup", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error("Gagal mendownload backup");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "backup.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: 'success',
        title: 'Berhasil!',
        text: 'File backup berhasil didownload.',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Gagal',
        text: 'Terjadi kesalahan saat mendownload file backup.',
      });
    }
  };

  return (
    <>
      <nav className="navbar">
        <div
          className="navbar-logo"
          onClick={() => navigate("/admin/dashboard")}
        >
          <img src={logo} alt="DuitKita Logo" />
        </div>

        <div className="navbar-links">
          {navLinks.map((link) => (
            <a
              key={link.path}
              href={link.path}
              className={location.pathname === link.path ? "active" : ""}
              onClick={(e) => {
                e.preventDefault();
                navigate(link.path);
              }}
            >
              {link.label}
            </a>
          ))}
          <button className="logout-btn backup-btn" onClick={handleBackup} style={{ backgroundColor: '#10b981', marginLeft: '10px' }}>
            <Download size={18} />
            Backup Data
          </button>
          <button className="logout-btn" onClick={handleLogout}>
            <LogOut size={18} />
            Logout
          </button>
        </div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </div>
      </nav>

      {/* Mobile menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                className={location.pathname === link.path ? "active" : ""}
                onClick={(e) => {
                  e.preventDefault();
                  setMenuOpen(false);
                  navigate(link.path);
                }}
              >
                {link.label}
              </a>
            ))}
            <button
              className="logout-btn mobile backup-btn"
              onClick={() => {
                setMenuOpen(false);
                handleBackup();
              }}
              style={{ backgroundColor: '#10b981', marginBottom: '10px' }}
            >
              <Download size={18} />
              Backup Data
            </button>
            <button
              className="logout-btn mobile"
              onClick={() => {
                setMenuOpen(false);
                handleLogout();
              }}
            >
              <LogOut size={18} />
              Logout
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
